import React from 'react'
import { isEmpty, uniqueId } from 'lodash'
import PropTypes from 'prop-types'
import useEmblaCarousel from 'embla-carousel-react'
import InstagramIcon from '../InstagramIcon'
import './styles.scss'

const options = { align: 'start', dragFree: false, loop: true, slidesToScroll: 1 }

export default function EmblaCarousel({ slides }) {
  const [emblaRef] = useEmblaCarousel(options)

  if (isEmpty(slides)) return null

  return (
    <section className="instagram-gallery">
      <div className="embla">
        <div className="embla__viewport" ref={emblaRef}>
          <div className="embla__container">
            {slides?.map((slide) => {
              const imageUrl =
                slide?.media_type === 'VIDEO' ? slide?.thumbnail_url : slide?.media_url

              return (
                <div className="embla__slide" key={uniqueId(slide?.id)}>
                  <a href={slide?.permalink} target="_blank" rel="noreferrer">
                    <figure>
                      <img loading="lazy" src={imageUrl} alt={slide?.caption} />
                      <figcaption className="sr-only">
                        <p>{slide?.caption}</p>
                      </figcaption>
                      <figcaption className="slide__overlay">
                        <InstagramIcon />

                        <p className="mt-4 paragraph text-white text-center">
                          Find us on Instagram
                        </p>
                        <p className="mt-1 paragraph text-white text-center uppercase">#AICandme</p>
                      </figcaption>
                    </figure>
                  </a>
                </div>
              )
            })}
          </div>
        </div>
      </div>
    </section>
  )
}

EmblaCarousel.propTypes = {
  slides: PropTypes.array,
}
